/* fk-nav.js — Fotouh AlKuwait instant navigation
   Swaps page content in place (header, pills and bottom nav stay put),
   pre-downloads pages on hover/touch, animates with a crossfade,
   shows a slim progress bar, and restores back/forward navigation
   instantly from memory with the scroll position preserved.
   Back/forward restores are fully synchronous (no animation, no script
   re-execution) so iOS swipe-back is seamless after Safari's gesture
   screenshot. Snapshots are keyed by BOTH a history-state id and the
   URL, so restores work even if other scripts overwrite history state.
   Falls back to a normal full page load on any error. */
(function () {
  'use strict';

  var CACHE = {};
  var TTL = 120000; /* 2 min in-memory page cache */
  var SKIP = /\/(checkout|cart|account|admin|challenge|password)/;
  var navigating = false;

  /* ---- back/forward snapshots: restore pages exactly as you left them ---- */
  var SNAP = {};     /* by id */
  var URLSNAP = {};  /* by URL — survives history.state being overwritten by other scripts */
  var SEQ = 0;
  function newId() { return 'fk' + (++SEQ) + '_' + Date.now(); }
  function urlKey(u) {
    try { var x = new URL(u, location.origin); return x.pathname + x.search; } catch (e) { return String(u); }
  }
  var curId = newId();

  function tagState() {
    try {
      var st = history.state || {};
      if (st.fkId !== curId) { st.fk = 1; st.fkId = curId; history.replaceState(st, '', location.href); }
    } catch (e) {}
  }
  tagState();
  /* other scripts (e.g. platform scripts in the page head) may replace history
     state after us — re-assert our tag once everything has loaded */
  window.addEventListener('load', function () { setTimeout(tagState, 250); });
  try { history.scrollRestoration = 'manual'; } catch (e) {}

  function snapshotCurrent() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var s = { html: main.innerHTML, title: document.title, scroll: window.scrollY || 0, t: Date.now() };
    SNAP[curId] = s;
    URLSNAP[urlKey(location.href)] = s;
    var keys = Object.keys(SNAP);
    if (keys.length > 15) {
      keys.sort(function (a, b) { return SNAP[a].t - SNAP[b].t; });
      delete SNAP[keys[0]];
    }
    var ukeys = Object.keys(URLSNAP);
    if (ukeys.length > 15) {
      ukeys.sort(function (a, b) { return URLSNAP[a].t - URLSNAP[b].t; });
      delete URLSNAP[ukeys[0]];
    }
  }

  function closeCartDrawer() {
    try {
      var dr = document.getElementById('fk-cart-drawer');
      if (dr && dr.classList.contains('on') && window.fkCart && window.fkCart.close) window.fkCart.close();
    } catch (e) {}
  }

  function eligible(a) {
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return null;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return null;
    var u;
    try { u = new URL(a.href, location.origin); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (SKIP.test(u.pathname)) return null;
    if (/\.(jpg|jpeg|png|gif|webp|svg|pdf|zip|js|css)$/i.test(u.pathname)) return null;
    return u;
  }

  function fetchPage(url) {
    var c = CACHE[url];
    if (c && (Date.now() - c.t) < TTL) return Promise.resolve(c.h);
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('fetch ' + r.status);
      return r.text().then(function (h) {
        CACHE[url] = { h: h, t: Date.now() };
        if (r.url && r.url !== url) CACHE[r.url] = { h: h, t: Date.now() };
        return h;
      });
    });
  }

  /* --- pre-download pages the moment a link is hovered or touched --- */
  function prefetch(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    var u = eligible(a);
    if (!u) return;
    var c = CACHE[u.href];
    if (c && (Date.now() - c.t) < TTL) return;
    fetchPage(u.href).catch(function () {});
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });

  /* --- slim progress bar --- */
  var bar = null;
  function progress(on) {
    if (on) {
      if (!bar) { bar = document.createElement('div'); bar.id = 'fk-progress'; document.body.appendChild(bar); }
      bar.classList.remove('on');
      void bar.offsetWidth;
      bar.classList.add('on');
    } else if (bar) {
      bar.classList.remove('on');
    }
  }

  /* innerHTML does not execute <script> tags — recreate them so they run */
  function execScripts(container) {
    var scripts = container.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      if (old.type && old.type !== 'text/javascript' && old.type !== 'module') continue;
      var s = document.createElement('script');
      for (var j = 0; j < old.attributes.length; j++) s.setAttribute(old.attributes[j].name, old.attributes[j].value);
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    }
  }

  function refreshChrome() {
    try { if (window.fkUI && window.fkUI.refreshPills) window.fkUI.refreshPills(); } catch (e) {}
    try { if (window.fkBottomNav && window.fkBottomNav.refresh) window.fkBottomNav.refresh(); } catch (e) {}
  }

  function applyDoc(doc, url) {
    var newMain = doc.querySelector('#MainContent');
    var main = document.getElementById('MainContent');
    if (!newMain || !main) { location.href = url; return false; }
    main.innerHTML = newMain.innerHTML;
    execScripts(main);
    document.title = doc.title;
    window.scrollTo(0, 0);
    refreshChrome();
    return true;
  }

  /* Back/forward restore: fully synchronous, no animation, no script
     re-execution. The snapshot is the exact DOM as the user left it
     (scripts already ran on it), so putting it back as-is is both the
     fastest and the safest — critical for seamless iOS swipe-back. */
  function restoreSnapshot(s) {
    var main = document.getElementById('MainContent');
    if (!main) return false;
    main.innerHTML = s.html;
    document.title = s.title;
    window.scrollTo(0, s.scroll || 0);
    refreshChrome();
    /* re-assert scroll after layout settles (lazy images can shift it) */
    requestAnimationFrame(function () { window.scrollTo(0, s.scroll || 0); });
    return true;
  }

  function go(url, push) {
    if (navigating) return;
    navigating = true;
    /* navigating away: make sure the cart drawer isn't left open over the new page */
    closeCartDrawer();
    progress(true);
    fetchPage(url).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* if the fetched page is in a different language/direction, do a normal full load */
      if (doc.documentElement.getAttribute('dir') !== document.documentElement.getAttribute('dir')) {
        location.href = url;
        return;
      }
      /* remember the page we're leaving, exactly as it looks now */
      snapshotCurrent();
      if (push) {
        curId = newId();
        try { history.pushState({ fk: 1, fkId: curId }, '', url); } catch (e) {}
      }
      if (document.startViewTransition) {
        document.startViewTransition(function () { applyDoc(doc, url); });
      } else {
        applyDoc(doc, url);
      }
      navigating = false;
      progress(false);
    }).catch(function () {
      navigating = false;
      progress(false);
      location.href = url;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    var u = eligible(a);
    if (!u) return;
    /* in-page anchors on the same page: let the browser handle them */
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return;
    e.preventDefault();
    go(u.href, true);
  });

  window.addEventListener('popstate', function (ev) {
    /* navigating away: make sure the cart drawer isn't left open over the restored page */
    closeCartDrawer();
    /* remember the page we're leaving so the forward button also restores instantly */
    snapshotCurrent();
    var st = ev.state;
    var id = st && st.fkId ? st.fkId : null;
    var s = (id && SNAP[id]) || URLSNAP[urlKey(location.href)] || null;
    if (s) {
      /* instant restore from memory — content and scroll position exactly as you left them */
      curId = id || newId();
      tagState();
      if (restoreSnapshot(s)) return;
    }
    curId = id || newId();
    tagState();
    go(location.href, false);
  });
}());
